import { Card } from 'primereact/card';

const AdminPage = () => (
  <Card>
    <h2>Placeholder: Administration pages</h2>
  </Card>
);

export default AdminPage;
